// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { AppConfig } from "../config";
// Initialize Firebase
const app = initializeApp(AppConfig.firebase);
const auth = getAuth(app);

export async function GetCurrentToken() {
  return await auth.currentUser?.getIdToken(true);
}

export const FbApp = app;
export const FbAuth = auth;
export const FbStorage = getStorage(FbApp);
export const FbAnalytics = getAnalytics(FbApp);
